<template>
  <div class="financialAudit">
    <div class="searchTop">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="colItem1">
          <van-search
            v-model="searchText"
            show-action
            shape="round"
            background="transparent"
            :placeholder="getPlaceHolder()"
          >
            <template #action>
              <div @click="onSearch">{{ $t.meta.search }}</div>
            </template>
          </van-search>
        </van-col>
        <van-col class="colItem2">
          <div :class="isFilter() ? 'isFilter' : ''">
            <span @click="showFilter = true">{{ $t.meta.filter }}</span>
          </div>
        </van-col>
      </van-row>
    </div>

    <van-tabs
      v-model="menuState"
      @change="stateChanged"
      title-active-color="#009ed4"
      color="#009ed4"
      swipeable
    >
      <van-tab
        v-for="(menu, index) in menuList"
        :key="index"
        :title="menu.title + (menu.count > 0 ? ' ' + menu.count : '')"
        :name="menu.name"
      >
        <van-list
          class="list"
          v-model="loading"
          :finished="finished"
          :finished-text="$t.meta.noMore"
          :error.sync="error"
          :error-text="errorText"
          @load="getList(page + 1)"
        >
          <div
            class="list-container"
            v-for="(item, index) in tableData"
            :key="index"
            @click="gotoDetail(item)"
          >
            <template v-if="menuState == 2">
              <div class="list-item">
                {{ $t.financialRequest.paymentRecordNumber }}：{{
                  item.OperationRecordNumber
                }}
              </div>
              <div class="list-item">
                {{ $t.financialRequest.applicant }}：{{ item.UserName }}
              </div>
              <div class="list-item">
                {{ $t.financialRequest.approvalState }}：
                <span v-if="item.ApprovalState == 0">{{
                  $t.financialRequest.aState1
                }}</span>
                <span v-if="item.ApprovalState == 1">{{
                  $t.financialRequest.aState2
                }}</span>
                <span v-if="item.ApprovalState == 2">{{
                  $t.financialRequest.aState3
                }}</span>
                <span v-if="item.ApprovalState == 3">{{
                  $t.financialRequest.aState4
                }}</span>
                <span v-if="item.ApprovalState == 4">{{
                  $t.financialRequest.aState5
                }}</span>
              </div>
              <div class="list-item">
                {{ $t.financialRequest.costAmount }}：{{ item.CurrencySn }}
                {{ item.FeeAmount }}
              </div>
              <div class="list-item">
                {{ $t.financialRequest.menthodState }}：
                <span v-if="item.PaymentMethod == 1">{{
                  $t.financialRequest.mState1
                }}</span>
                <span v-if="item.PaymentMethod == 2">{{
                  $t.financialRequest.mState2
                }}</span>
                <span v-if="item.PaymentMethod == 3">{{
                  $t.financialRequest.mState3
                }}</span>
              </div>
            </template>
            <template v-else>
              <div class="list-item">
                {{ $t.financialRequest.paymentRecordNumber }}：{{
                  item.PaymentRecordNumber
                }}
              </div>
              <div class="list-item">
                {{ $t.financialRequest.applicant }}：{{ item.UserName }}
              </div>
              <div class="list-item">
                {{ $t.financialRequest.supplierName }}：{{ item.CustomerName }}
              </div>
              <div class="list-item">
                {{ $t.financialRequest.voucherNumber }}：{{ item.SupplierVoucherNumber }}
              </div>
              <div class="list-item">
                {{ $t.financialRequest.approvalState }}：
                <span v-if="item.ApprovalState == 0">{{
                  $t.financialRequest.aState1
                }}</span>
                <span v-if="item.ApprovalState == 1">{{
                  $t.financialRequest.aState2
                }}</span>
                <span v-if="item.ApprovalState == 2">{{
                  $t.financialRequest.aState3
                }}</span>
                <span v-if="item.ApprovalState == 3">{{
                  $t.financialRequest.aState4
                }}</span>
                <span v-if="item.ApprovalState == 4">{{
                  $t.financialRequest.aState5
                }}</span>
              </div>
            </template>
            <div class="list-item">
              {{ $t.financialRequest.paymentState }}：
              <span v-if="item.PaymentState == 0">{{ $t.financialRequest.pState1 }}</span>
              <span v-if="item.PaymentState == 1">{{ $t.financialRequest.pState2 }}</span>
            </div>
          </div>
        </van-list>
      </van-tab>
    </van-tabs>

    <van-popup
      v-model="showFilter"
      position="bottom"
      :style="{ height: '80%', width: '100%' }"
    >
      <div class="popup-header">{{ $t.meta.allFilter }}</div>
      <van-form>
        <div class="radio-label">{{ $t.meta.searchType }}</div>
        <van-radio-group v-model="searchType" direction="horizontal">
          <van-radio
            :name="item.value"
            v-for="(item, index) in searchTypeOptions"
            :key="index"
            >{{ item.text }}</van-radio
          >
        </van-radio-group>

        <div class="radio-label">{{ $t.financialRequest.approvalState }}</div>
        <van-radio-group v-model="approvalState" direction="horizontal">
          <van-radio :name="0">{{ $t.financialRequest.aState1 }}</van-radio>
          <van-radio :name="1">{{ $t.financialRequest.aState2 }}</van-radio>
          <van-radio :name="2">{{ $t.financialRequest.aState3 }}</van-radio>
          <van-radio :name="3">{{ $t.financialRequest.aState4 }}</van-radio>
          <van-radio :name="4">{{ $t.financialRequest.aState5 }}</van-radio>
        </van-radio-group>

        <div class="radio-label">{{ $t.financialRequest.paymentState }}</div>
        <van-radio-group v-model="paymentState" direction="horizontal">
          <van-radio :name="0">{{ $t.financialRequest.pState1 }}</van-radio>
          <van-radio :name="1">{{ $t.financialRequest.pState2 }}</van-radio>
        </van-radio-group>

        <div class="radio-label">{{ $t.financialRequest.menthodState }}</div>
        <van-radio-group v-model="paymentMethod" direction="horizontal">
          <van-radio :name="1">{{ $t.financialRequest.mState1 }}</van-radio>
          <van-radio :name="2">{{ $t.financialRequest.mState2 }}</van-radio>
          <van-radio :name="3">{{ $t.financialRequest.mState3 }}</van-radio>
        </van-radio-group>

        <div class="radio-label">{{ $t.meta.dateFilter }}</div>
        <van-radio-group v-model="dateConditions" direction="horizontal">
          <van-radio :name="1">{{ $t.financialRequest.submitDate }}</van-radio>
          <van-radio :name="2">{{ $t.financialRequest.lastDate }}</van-radio>
          <van-radio :name="3">{{ $t.financialRequest.uploadDate }}</van-radio>
        </van-radio-group>

        <div class="custom-date">
          <div class="date-label">{{ $t.meta.date }}</div>
          <van-button class="date-btn1" type="info" size="small" @click="showStartDate">{{
            $t.meta.beginDate
          }}</van-button>
          <van-button class="date-btn2" type="info" size="small" @click="showEndDate">{{
            $t.meta.endDate
          }}</van-button>
          <div class="date-txt" v-if="beginTime || endTime">
            {{ beginTime }} {{ $t.meta.to }} {{ endTime }}
          </div>
        </div>
      </van-form>
      <div class="popup-footer">
        <van-button class="reset" type="info" block square @click="filterReset">{{
          $t.meta.reset
        }}</van-button>

        <van-button class="confirm" type="primary" block square @click="filterSubmit">{{
          $t.meta.confirm
        }}</van-button>
      </div>
    </van-popup>

    <van-popup v-model="showStartPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.meta.beginDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event, 'start')"
        @cancel="showStartPicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <van-popup v-model="showEndPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.meta.endDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event, 'end')"
        @cancel="showEndPicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <div class="tool-bar" v-if="position">
      <div class="tool-bar-text">{{ $t.financialRequest.position }} : {{ position }}</div>
    </div>
  </div>
</template>

<script>
import {
  List,
  Row,
  Col,
  Search,
  Button,
  Form,
  Field,
  ActionSheet,
  Popup,
  Picker,
  DatetimePicker,
  Radio,
  RadioGroup,
  Tab,
  Tabs,
} from "vant";

import Vue from "vue";
Vue.use(List)
  .use(Row)
  .use(Col)
  .use(Search)
  .use(Button)
  .use(Form)
  .use(Field)
  .use(ActionSheet)
  .use(Popup)
  .use(Picker)
  .use(DatetimePicker)
  .use(Radio)
  .use(RadioGroup)
  .use(Tab)
  .use(Tabs);

export default {
  name: "financialAudit",
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      menuState: this.$route.query.state
        ? this.$route.query.state
        : parseInt(localStorage.getItem("MenuState")),
      menuList: [
        {
          title: this.$t.financialRequest.tab1,
          name: 1,
          count: 0,
        },
        {
          title: this.$t.financialRequest.tab2,
          name: 2,
          count: 0,
        },
      ],
      page: 0,
      pageSize: 10,
      tableData: [],
      position: "",
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      //filter
      searchText: "",
      searchType: 1,
      searchTypeOptions: [
        {
          text: this.$t.financialRequest.recordNumber,
          value: 1,
        },
        {
          text: this.$t.financialRequest.applicant,
          value: 2,
        },
        {
          text: this.$t.financialRequest.department,
          value: 3,
        },
        {
          text: this.$t.financialRequest.supplierName,
          value: 4,
        },
        {
          text: this.$t.financialRequest.voucherNumber,
          value: 5,
        },
        {
          text: this.$t.financialRequest.systemCode,
          value: 6,
        },
        {
          text: this.$t.financialRequest.creditRefNo,
          value: 7,
        },
        {
          text: this.$t.financialRequest.costCode,
          value: 8,
        },
      ],
      paymentMethod: null,
      approvalState:
        JSON.parse(localStorage.getItem("auth")).userInfo.IsCashier == 1 ? 4 : 0,
      paymentState: null,
      dateConditions: null,
      showFilter: false,
      //日期
      selectDate: new Date(),
      currentDate: "",
      showStartPicker: false,
      beginTime: "",
      showEndPicker: false,
      endTime: "",
    };
  },
  watch: {
    menuState() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.tableData = [];
      this.getList();
    },
  },
  created() {},
  methods: {
    gotoDetail(item) {
      var data = item;
      data.PaymentType = this.menuState;
      localStorage.setItem("financialAuditDetail", JSON.stringify(data));
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "financialAuditDetail",
        name: "financialAuditDetail",
        query: [],
      });
    },
    getPlaceHolder() {
      var search = this.searchTypeOptions.find((c) => c.value == this.searchType);
      if (search) {
        return search.text;
      } else {
        return this.$t.meta.searchText;
      }
    },
    onSearch() {
      this.initList();
      this.getList(1);
    },
    isFilter() {
      if (
        this.paymentState ||
        this.paymentMethod ||
        this.dateConditions ||
        (this.beginTime && this.endTime)
      ) {
        return true;
      } else {
        return false;
      }
    },
    filterReset() {
      this.searchText = "";
      this.searchType = 1;
      if (JSON.parse(localStorage.getItem("auth")).userInfo.IsCashier == 1) {
        this.approvalState = 4;
      } else {
        this.approvalState = 0;
      }
      this.paymentState = null;
      this.paymentMethod = null;
      this.dateConditions = null;
      this.beginTime = "";
      this.endTime = "";
      this.initList();
      this.getList(1);
    },
    filterSubmit() {
      this.initList();
      this.getList(1);
    },
    initList() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.showFilter = false;
      this.tableData = [];
    },
    showStartDate() {
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = start;
      this.showStartPicker = true;
    },
    showEndDate() {
      var end = new Date();
      end.setTime(end.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = end;
      this.showEndPicker = true;
    },
    formatter(type, val) {
      if (type === "year") {
        return val + this.$t.meta.year;
      }
      if (type === "month") {
        return val + this.$t.meta.month;
      }
      if (type === "day") {
        return val + this.$t.meta.day;
      }
      return val;
    },
    dateChange(date, type) {
      var formatDate = (val) => {
        var time = new Date(val).toLocaleDateString();
        let [year, month, date] = time.split("/");
        if (month < 10) {
          month = "0" + month;
        }
        if (date < 10) {
          date = "0" + date;
        }
        return year + "-" + month + "-" + date;
      };
      if (type == "start") {
        this.beginTime = formatDate(date);
        this.showStartPicker = false;
      }
      if (type == "end") {
        this.endTime = formatDate(date);
        this.showEndPicker = false;
      }
    },
    stateChanged(state) {
      this.menuState = state;
      localStorage.setItem("MenuState", JSON.stringify(state));
      this.searchText = "";
      this.searchType = 1;
    },
    getList(page) {
      var param = {
        PageIndex: page,
        PageSize: this.pageSize,
        ApprovalState: this.approvalState,
        PaymentState: this.paymentState,
        PaymentMethod: this.paymentMethod,
        DateConditions: this.dateConditions,
        PaymentRecordNumber: this.searchType == 1 ? this.searchText : "",
        UserName: this.searchType == 2 ? this.searchText : "",
        Department: this.searchType == 3 ? this.searchText : "",
        CustomerName: this.searchType == 4 ? this.searchText : "",
        SupplierVoucherNumber: this.searchType == 5 ? this.searchText : "",
        PaymentSystemCode: this.searchType == 6 ? this.searchText : "",
        NuclearAccountNo: this.searchType == 7 ? this.searchText : "",
        ExpenseVoucherNumber: this.searchType == 8 ? this.searchText : "",
        BeginTime: this.beginTime,
        EndTime: this.endTime,
      };
      var request = null;
      if (this.menuState == 2) {
        param.PaymentType = 2;
        request = this.$api.financialManagement.getFinancialAuditList(param);
      } else {
        param.PaymentType = 1;
        request = this.$api.financialManagement.getFinancialAuditList(param);
      }
      request
        .then((res) => {
          var data = res.data.dataPage;
          this.position = res.data.AuditPosition;
          this.tableData = this.tableData.concat(data.Data);
          this.loading = false;
          this.error = false;
          this.errorText = "";

          this.page = data.PageIndexs;
          this.finished = this.page >= data.ALLPages;
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.financialAudit {
  .searchTop {
    width: 100%;
    background-color: #ffffff;
    .search-top-row {
      width: 100%;
      text-align: center;
      background-color: transparent;
      .colItem1 {
        width: 80%;
        text-align: center;
        font-size: 14px;
        .van-search__content {
          padding: 0px;
          margin-right: 10px;
          .van-cell {
            padding: 5px 8px 5px 8px;
          }
        }
        .custom-date {
          padding: 10px;
          .date-btn1 {
            width: 40%;
            display: inline-block;
            border-right: 1px solid #ebedf0;
            line-height: 33px;
            vertical-align: middle;
          }
          .date-btn2 {
            width: 40%;
            display: inline-block;
            line-height: 33px;
            vertical-align: middle;
          }
          .van-button {
            vertical-align: middle;
          }
        }
      }
      .colItem2 {
        width: 20%;
        text-align: center;
        font-size: 14px;
        .isFilter {
          color: $-color-primary;
          font-weight: bold;
        }
      }
    }
  }
  .list {
    .list-container {
      font-size: 12px;
      color: #333;
      padding: 10px;
      margin-top: 10px;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
      .list-item {
        margin-bottom: 10px;
      }
      .list-item:last-child {
        margin-bottom: 0px;
      }
      .buttons {
        text-align: right;
        padding-bottom: 10px;
        .primary-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-primary;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .default-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-light-gray;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .search-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-green;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .danger-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-red;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
      }
    }
  }
  .popup-header {
    margin-top: 20px;
    margin-bottom: 10px;
    padding-bottom: 10px;
    text-align: center;
    font-size: 16px;
  }
  .radio-label {
    color: #646566;
    margin-bottom: 10px;
    font-size: 14px;
  }
  .van-radio-group {
    margin-bottom: 20px;
  }
  .van-radio {
    margin-bottom: 10px;
    font-size: 14px;
    ::v-deep .van-radio__label {
      color: #646566;
    }
  }
  .van-form {
    width: 90%;
    margin: auto;
    padding-bottom: 20vw;
    .van-cell:after {
      border: none;
    }
    .van-cell {
      border-bottom: 1px solid #ebedf0;
    }
    .custom-date {
      text-align: center;
      border-bottom: 1px solid #ebedf0;
      padding-bottom: 20px;
      .date-label {
        text-align: left;
        font-size: 14px;
        color: #646566;
        margin-left: 15px;
        margin-bottom: 10px;
        margin-top: 10px;
      }
      .date-btn1 {
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-btn2 {
        margin-left: 30px;
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-txt {
        margin-top: 20px;
        font-size: 14px;
        color: #999;
        border-radius: 10px;
      }
    }
  }
  .popup-footer {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 100;
    background-color: white;
    padding-bottom: env(safe-area-inset-bottom);
    width: 100%;
    .reset {
      width: 50%;
      display: inline-block;
      color: $-color-primary;
      background: #ffffff;
      border: none;
    }
    .confirm {
      width: 50%;
      display: inline-block;
      color: #ffffff;
      background: $-color-primary;
      border: none;
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    border-top: 1px solid #f6f6f6;
    .tool-bar-text {
      border-top: 1px solid #e5e5e5;
      padding: 10px;
      text-align: center;
      color: #1e90ff;
    }
  }
}
</style>
